module.exports = __webpack_public_path__ + "static/media/automation-5.1fe72fe2.png";